import React from 'react';
// Components
import CampaignsTable from './components/CampaignsTable/CampaignsTable';

const Campaigns = (): JSX.Element => {
  return <CampaignsTable />;
};

export default Campaigns;
